<template>
  <div>
    <label style="display: flex; position: relative; align-items: center">
      <vs-input
        class="field-select-input w-full h-full"
        style="border-radius: 5px"
        placeholder="환경시설 불러오기"
        :readonly="readonly"
        :value="selectValue"
        @click="handleClickInput"
      />
      <vs-icon icon-pack="feather" icon="icon-droplet" style="padding-left: 6px; padding-right: 6px; position: absolute; top: auto; right: 0; bottom: auto; font-size: 24px; border-left: 1px solid #cdcdcd"></vs-icon>
    </label>

    <popup-select977 v-model="showPopup" @select="onSelect"/>
  </div>
</template>

<script>

import PopupSelect977 from "@/views/boards/single-page/977/PopupSelect977.vue";

export default {
  components: {PopupSelect977},
  props: {
    value: Object,
    label: {
      type: String,
      default: "공정분류 선택"
    },
    readonly: Boolean,
  },
  computed: {
    model: {
      get () {
        return this.value;
      },
      set (val) {
        this.$emit('input', val);
      }
    },
    selectValue () {
      return this.model ? this.model.공정명 : '';
    }
  },
  data () {
    return {
      showPopup: false
    }
  },
  methods: {
    handleClickInput() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    onSelect (data) {
      let model = {}
      if (data) {
        model = {
          ...data.body.시설정보,
          id: data.id,
          사업장: {
            id: data.body.stdInfo.field_id,
            사업장명: data.body.stdInfo.field_name
          },
        }
      }
      this.model = model;
    }
  }
}
</script>

<style scoped>

</style>
